import React from 'react';
import { useTranslation } from 'react-i18next';
import { Utils } from '../../services';
import SelectField from '../SelectField/SelectField';

const CashOutflowComputeModeField = ({ name }) => {
    const { t } = useTranslation();
    const options = Utils.cashOutflowComputeModeOptions().map(mode => ({
        key: mode,
        text: t(`settings.payment.method.cash.cash_outflow_compute_mode_${mode}`),
        value: mode,
    }));

    return (
        <SelectField
            name={name}
            options={options}
            format={v => (v == null || v === '' ? Utils.CASH_OUTFLOW_COMPUTE_MODE_AUTO : v)}
            parse={v => v}
            clearable={false}
            search={false}
        />
    );
};

export default CashOutflowComputeModeField;
